export default __webpack_public_path__ + "static/media/when-you-can-start.59dcb37d.svg";